import { render, staticRenderFns } from "./ManejoProspectos.vue?vue&type=template&id=ad027eaa"
import script from "./ManejoProspectos.vue?vue&type=script&lang=js"
export * from "./ManejoProspectos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports